/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Button } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import classnames from 'classnames';

interface IPayAllDueInvoicesButtonProps {
    className: string;
    addDueInvoicesToCartLabel: string;
    onClicked(): void;
    isPayAllDueEnabled: boolean;
    isLoading: boolean;
    limitNote: string;
}

export const PayAllDueInvoicesButton: React.FC<IPayAllDueInvoicesButtonProps> = ({
    className,
    onClicked,
    addDueInvoicesToCartLabel,
    isPayAllDueEnabled,
    isLoading,
    limitNote
}) => {
    return (
        <div className={`${className}__payAllDueInvoices`}>
            <Button
                className={classnames(`${className}__payAllDueInvoicesButton`, { loading: !!isLoading })}
                onClick={() => {
                    if (!isLoading) {
                        onClicked();
                    }
                }}
                disabled={!isPayAllDueEnabled || !!isLoading}
            >
                {addDueInvoicesToCartLabel}
            </Button>

            <div className={`${className}__payAllDueInvoicesNote`}>{limitNote}</div>
        </div>
    );
};
